import { render, staticRenderFns } from "./MatterNoteForm.vue?vue&type=template&id=5a61d20a&"
import script from "./MatterNoteForm.vue?vue&type=script&lang=js&"
export * from "./MatterNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterNoteForm.vue?vue&type=style&index=0&id=5a61d20a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports